import { render, staticRenderFns } from "./CadastroTef.vue?vue&type=template&id=1b6fdf6d&scoped=true"
import script from "./CadastroTef.vue?vue&type=script&lang=js"
export * from "./CadastroTef.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6fdf6d",
  null
  
)

export default component.exports